const THEME_KEY = 'zuri-theme';

export function initTheme(): void {
  const saved = localStorage.getItem(THEME_KEY) || 'light';
  document.documentElement.setAttribute('data-theme', saved);
}

export function toggleTheme(): void {
  const current = document.documentElement.getAttribute('data-theme') || 'light';
  const next = current === 'light' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem(THEME_KEY, next);
}

export function renderThemeToggle(): string {
  return `
    <button class="btn btn-ghost btn-sm" id="themeToggle" aria-label="Toggle theme">
      <i class="fa-solid fa-moon"></i>
    </button>
  `;
}

export function wireThemeToggle(): void {
  document.getElementById('themeToggle')?.addEventListener('click', () => {
    toggleTheme();
    const icon = document.querySelector('#themeToggle i');
    const theme = document.documentElement.getAttribute('data-theme');
    if (icon) {
      icon.className = `fa-solid ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`;
    }
  });
}